import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';
import type { PageLoadMetric } from '@atlassian/browser-metrics/page-load-metric';

import {
	createPageLoadMetric,
	createPageSegmentLoadMetric,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY,
	ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const ADMIN_ANNOUNCEMENT_BANNER_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY,
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
});

export const ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD: PageLoadMetric = createPageLoadMetric({
	key: ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY,
});
